module.exports = __webpack_public_path__ + "img/berry.3a89633e.png";